import "./Deck.css";
import { useGameContext } from "../../../context/gameContext/gameContext";
import PlayingCard from "./PlayingCard";

const TrickContainer = ({
  playerInfo,
  playCardUpdateTable,
  trick,
  trickOver,
  trickAwardClass,
}) => {
  const trickContainerCards = trick.map((card) => {
    return (
      <PlayingCard
        className={`${card.details.owner}C`}
        id={card.details.owner}
        owner={card.player}
        key={card.details.card}
        card={card.details.card}
        url={card.details.url}
        faceUp={card.details.faceUp}
        suit={card.suit}
        alt={card.details.card}
        shouldDarken={card.shouldDarken}
        playerInfo={playerInfo}
        playCardUpdateTable={playCardUpdateTable}
      />
    );
  });

  return (
    <div className={trickAwardClass ? `trick ${trickAwardClass}` : "trick"}>
      {trickContainerCards}
    </div>
  );
};
export default TrickContainer;
